/*
 * File: ja-JP.ts
 * File Created: 2023-12-05 02:19:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-09 10:57:18
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterBaseLanguage } from "./core";
import { IBaseLang } from "./core";

@RegisterBaseLanguage("ja-JP", "日本語")
export default class LangObject implements IBaseLang {
    /// generic terms //////////////////
    w_Description = "説明";
    w_Email = "Eメール";
    w_Name = "名";
    w_Username = "ユーザー";
    w_Password = "パスワード";
    w_Index = "シリアル";
    w_Date = "日付";
    w_Id = "ID";
    w_Age = "歳";
    w_CreatedAt = "作成日";
    w_UpdatedAt = "変更日";
    w_BeginAt = "開始日";
    w_EndAt = "終了日";
    w_Image = "イメージ";
    w_Yes = "はい";
    w_No = "いいえ";
    w_On = "オン";
    w_Off = "オフ";
    w_Reload = "リロード";
    w_Unknown = "未知";
    w_Menu = "メニュー";
    w_Home = "ホーム";
    w_Loading = "読み込み中";
    w_Detail = "詳細";
    w_Role = "ロール";
    w_RolePermission = "ロール権限";
    w_IsEnabled = "有効？";
    w_Log = "ログ";
    w_Priority = "優先度";
    w_Category = "カテゴリー";
    w_ErrorMessage = "エラーメッセージ";
    w_OtherMessage = "その他のメッセージ";
    w_System = "システム";
    w_Status = "状態";
    w_NICs = "ネットワークインターフェース";
    w_Manufacturer = "メーカー";
    w_Brand = "ブランド";
    w_Speed = "スピード";
    w_Cores = "コア数";
    w_PhysicalCores = "物理コア数";
    w_Memory = "メモリ";
    w_Disks = "ディスク";
    w_Device = "デバイス";
    w_Type = "タイプ";
    w_SerialNumber = "シリアル番号";
    w_Actions = "アクション";

    w_Common = "一般的な";
    w_NextPage = "次へ";
    w_PreviousPage = "前へ";
    w_Search = "検索する";
    w_Browse = "ブラウズ";
    w_NextStep = "次へ";
    w_PreviousStep = "前へ";
    w_Done = "完了";
    w_Save = "保存";
    w_Test = "テスト";
    w_Success = "成功";
    w_Error = "エラー";
    w_Language = "言語";
    w_Title = "タイトル";
    w_Every = "毎";
    w_EveryMonth = "毎月";

    w_Login = "ログイン";
    w_Logout = "ログアウト";
    w_ConfirmPassword = "パスワードの確認";
    w_NewPassword = "新しいパスワード";
    w_ConfirmChangePassword = "パスワードを変更しますか?";
    w_LoginFailed = "ログインに失敗しました。";

    w_Add = "追加";
    w_Delete = "削除";
    w_Edit = "編集";
    w_Export = "エクスポート";
    w_Import = "インポート";
    w_Info = "情報";
    w_View = "表示";
    w_More = "もっと";

    w_Submit = "入力";
    w_Reset = "リセット";
    w_Undo = "元に戻す";

    w_Confirm = "決定する";
    w_Cancel = "キャンセル";
    w_Close = "閉じる";
    w_ReLogin = "再ログイン";
    w_Back = "戻る";
    w_Finish = "実行する";

    w_Upload = "アップロード";
    w_Change = "変更";
    w_Remove = "削除";
    w_Abort = "中止";
    w_Retry = "再試行";

    w_Second = "秒";
    w_Minute = "分";
    w_Hour = "時間";
    w_Day = "日";
    w_Month = "月";
    w_Year = "年";

    w_Online = "オンライン";
    w_Offline = "オフライン";

    w_Enabled = "有効";
    w_Disabled = "無効";

    // datetime
    w_Weekday = "週";
    w_Time = "時間";
    w_DateTime_ShortWeekDay0 = "日曜";
    w_DateTime_ShortWeekDay1 = "月曜";
    w_DateTime_ShortWeekDay2 = "火曜";
    w_DateTime_ShortWeekDay3 = "水曜";
    w_DateTime_ShortWeekDay4 = "木曜";
    w_DateTime_ShortWeekDay5 = "金曜";
    w_DateTime_ShortWeekDay6 = "土曜";

    w_DateTime_NormalWeekDay0 = "日曜日";
    w_DateTime_NormalWeekDay1 = "月曜日";
    w_DateTime_NormalWeekDay2 = "火曜日";
    w_DateTime_NormalWeekDay3 = "水曜日";
    w_DateTime_NormalWeekDay4 = "木曜日";
    w_DateTime_NormalWeekDay5 = "金曜日";
    w_DateTime_NormalWeekDay6 = "土曜日";

    w_DateTime_ShortMonth01 = "一月";
    w_DateTime_ShortMonth02 = "二月";
    w_DateTime_ShortMonth03 = "三月";
    w_DateTime_ShortMonth04 = "四月";
    w_DateTime_ShortMonth05 = "五月";
    w_DateTime_ShortMonth06 = "六月";
    w_DateTime_ShortMonth07 = "七月";
    w_DateTime_ShortMonth08 = "八月";
    w_DateTime_ShortMonth09 = "九月";
    w_DateTime_ShortMonth10 = "十月";
    w_DateTime_ShortMonth11 = "十一月";
    w_DateTime_ShortMonth12 = "十二月";

    w_DateTime_NormalMonth01 = "一月";
    w_DateTime_NormalMonth02 = "二月";
    w_DateTime_NormalMonth03 = "三月";
    w_DateTime_NormalMonth04 = "四月";
    w_DateTime_NormalMonth05 = "五月";
    w_DateTime_NormalMonth06 = "六月";
    w_DateTime_NormalMonth07 = "七月";
    w_DateTime_NormalMonth08 = "八月";
    w_DateTime_NormalMonth09 = "九月";
    w_DateTime_NormalMonth10 = "十月";
    w_DateTime_NormalMonth11 = "十一月";
    w_DateTime_NormalMonth12 = "十二月";

    w_DateTime_AM = "朝";
    w_DateTime_PM = "午後";
    ////////////////////////////////////

    /// for component used mb, put inside this block /////
    // iv-table
    w_ShowCurrentEntries = "{total} 件中，{curStart} 件 - {curEnd} 件";
    w_ShowEntries = "{0} ペンデータを表示";
    w_NoDataAvailable = "データなし";
    w_ConnectionError = "接続エラー";
    // iv-table-cell
    w_CellNullText = "なし";
    // iv-input-file-classic
    w_IFCNoFileChosen = "ファイルが選択されていません";
    // iv-input-tree-select
    w_PleaseSelect = "選択してください";
    w_InputTreeSelectNoAvailable = "使用可能なオプションはありません";
    // iv-input-file
    w_InputFileAddNew = "ファイルを追加";
    w_InputFileSelect = "ファイルを選択";
    w_InputFileNoFile = "ファイルなし";
    w_InputFileNotImageHint = "その他のファイル";
    w_InputFileHint = "ファイルをここにドラッグするか、{0}参照{1}してください";
    w_InputFileInvalidField = "フィールドに無効なファイルが含まれています";
    w_InputFileWaitingForSize = "サイズを待機中";
    w_InputFileSizeNotAvailable = "サイズがありません";
    w_InputFileLoadError = "ロード中のエラー";
    w_InputFileUploading = "アップロード中";
    w_InputFileUploadComplete = "アップロードが完了しました";
    w_InputFileUploadAborted = "アップロードがキャンセルされました";
    w_InputFileUploadError = "アップロード中のエラー";
    w_InputFileRevertError = "元に戻すときにエラーが発生しました";
    w_InputFileRemoveError = "削除中のエラー";
    w_InputFileTapToCancel = "タップしてキャンセル";
    w_InputFileTapToRetry = "タップして再試行します";
    w_InputFileTapToUndo = "タップして元に戻します";
    // iv-input-table
    w_InputTableConfirmDelete = "データ削除の確認";
    w_InputTableConfirmDeleteMessage = "削除してもよろしいですか？";

    // iv-form
    w_RequiredField = "これは必要項目です";
    // iv-input-cron
    w_InputCronPlaceholder = "タイミング戦略を選択してください";
    w_InputCronSecondEvery = "毎秒";
    w_InputCronSecondCriteria = "最初は{0}秒から始まり、そこから{1}秒ごとに";
    w_InputCronSecondSpecific = "特定の秒数{0}";
    w_InputCronSecondBetween = "{0}と{1}の間の毎秒";
    w_InputCronMinuteEvery = "毎分";
    w_InputCronMinuteCriteria = "最初は{0}分から始まり、そこから{1}分ごとに";
    w_InputCronMinuteSpecific = "特定の分{0}";
    w_InputCronMinuteBetween = "{0}と{1}の間の毎分";
    w_InputCronHourEvery = "時間ごと";
    w_InputCronHourCriteria = "最初は{0}時間から始まり、そこから{1}時間ごとに";
    w_InputCronHourSpecific = "特定の時間{0}";
    w_InputCronHourBetween = "{0}から{1}までの 1 時間ごと";
    w_InputCronDayEvery = "毎日";
    w_InputCronDayCriteria = "毎月{0}日に始まり、その後は毎月{1}日";
    w_InputCronDayOfWeek = "毎週{0}";
    w_InputCronDayOfMonth = "毎月の{0}";
    w_InputCronDayLastDayOfMonth = "{w_EveryMonth}の最終日";
    w_InputCronDayLastWeekdayOfMonth = "{w_EveryMonth}の最終営業日";
    w_InputCronDayLastDayOfWeek = "{w_EveryMonth}{0}の最終週";
    w_InputCronDayBeforeLastDayOfMonth = "{w_EveryMonth}末の{0}日前";
    w_InputCronDayNearestWeekday = "{w_EveryMonth}の{0}に最も近い営業日";
    w_InputCronDayNumberedDayOfWeek = "{w_EveryMonth}の{0}第{1}週";
    w_InputCronMonthEvery = "毎月";
    w_InputCronMonthCriteria = "{0}月に始まり、その後は{1}か月ごと";
    w_InputCronMonthSpecific = "特定の月{0}";
    w_InputCronMonthBetween = "{0}月から{1}月までの毎月";
    w_InputCronYearEvery = "毎年";
    w_InputCronYearCriteria = "{0}年に始まり、その後は{1}年ごと";
    w_InputCronYearSpecific = "特定の年{0}";
    w_InputCronYearBetween = "毎年{0}から{1}まで";
    w_InputCronReadTextYear = "{0}年";
    w_InputCronReadTextMonth = "{0}月";
    w_InputCronReadTextDay = "{0}日";
    w_InputCronReadTextHour = "{0}時";
    w_InputCronReadTextMinute = "{0}分";
    w_InputCronReadTextSecond = "{0}秒";
    w_InputCronReadTextYearSp = "特定の年";
    w_InputCronReadTextMonthSp = "特定の月";
    w_InputCronReadTextDaySp = "特定の日";
    w_InputCronReadTextHourSp = "特定の時";
    w_InputCronReadTextMinuteSp = "特定の分";
    w_InputCronReadTextSecondSp = "特定の秒数";
    w_InputCronReadTextYearEvery = "毎年";
    w_InputCronReadTextMonthEvery = "毎月";
    w_InputCronReadTextDayEvery = "毎日";
    w_InputCronReadTextHourEvery = "毎時";
    w_InputCronReadTextMinuteEvery = "毎分";
    w_InputCronReadTextSecondEvery = "毎秒";
    w_InputCronReadTextMonthOdd = "奇数月";
    w_InputCronReadTextMonthEven = "偶数月";
    // iv-form-file
    w_FileExceedLimit = "ファイル サイズが制限 ({limit}) を超えています";
    // iv-form-password
    w_RequireValidPassword =
        "パスワードは {length} 文字以上で、大文字、小文字、記号を含める必要があります";
    // iv-form-square-meter
    w_SquareMeter = "平方メートル";
    w_Tsubo = "坪";

    // ui-validate-unique
    w_FormUniqueStringValidating = "検証中...";
    w_FormUniqueStringValidated = "検証に合格しました";
    w_FormUniqueStringBeenUsed = `"{0}" は使用されました`;
    // ui-validate-email
    w_RequireValidEmailFormat = "正しい Email 形式を入力してください";
    // ui-validate-ip
    w_RequireValidIPFormat = "正しい IP 形式を入力してください";
    // ui-form-quick-table
    w_AutofillAfterCreate = "作成後に自動入力";

    // http alert
    w_StatusUnknown = "リクエストが失敗しました";
    w_StatusUnknown_Message =
        "サーバーから応答がありません。 一般的にはIP /ポートエラーまたはサーバーのダウンが原因で発生しました。";
    w_Status400 = "リクエストが不正である";
    w_Status400_Message =
        "<b>エラーコード {0}</b> - クライアントエラーのため、サーバーは要求を処理できません。 リクエストとともに送信されたパラメータを確認してください。";
    w_Status401 = "認証無効／接続タイムアウト";
    w_Status401_Message =
        "本人確認ができないか、接続がタイムアウトしました。続行するには再度ログインしてください。";
    w_Status403 = "禁止されている";
    w_Status403_Message =
        "<b>エラーコード {0}</b> - このページをリクエストするには許可が必要です。";
    w_Status404 = "未検出";
    w_Status404_Message = "<b>エラーコード {0}</b> - このリソースにアクセスできません。";
    w_Status422 = "処理不可";
    w_Status422_Message =
        "リクエスト形式は正しいですが、意味的なエラーのためサーバーで処理できません。入力情報の完全性または正確性を確認してください。";
    w_Status500 = "サーバ内部エラー";
    w_Status500_Message = "<b>エラーコード {0}</b> - 不明なサーバーエラーです。";
    /////////////////////////////////////////////////////

    w_FormMultipleClickToAdd = "クリックしてデータを追加";

    w_VersionLimitation = "バージョン制限";
    w_VersionNotEnough =
        "ServerFrameworkのバージョンは v{version} より大きくなければなりません。";
    w_PermissionDenied = "アクセス拒否";
    w_PermissionDeniedLong = "このエリアにアクセスできない。";
    w_ContentInvalid = "コンテンツ無効";

    w_ConfirmDelete = "本当に削除しますか？";
    w_FormSelectionNoResult = "可能なオプションがありません";
    w_NoFileChosen = "ファイルが選択されていません";

    /// validation message
    w_ValidateRequireConsent = "同意が必要です";
    w_ValidateRange = "(範囲： {min}-{max})";
    w_ValidateRangePercent = "(範囲： {min}-{max}%)";
    w_ValidationIp = "有効な IP 形式を入力してください。";
    w_ValidationLicense = "有効な License 形式を入力してください。";
    w_ValidationNumber = "範囲内の数値を入力してください ({min}-{max})。";
    w_ValidationEmail = "有効な Email 形式を入力してください。";
    w_ValidationImageFile =
        "拡張子は.jpg / .jpeg / .png / .bmpで、ファイルサイズは{0} MB未満である必要があります。";

    /// form-datetime
    w_Date_Not_Selected = "日付を選択する";
    w_Time_Not_Selected = "時間を選択する";

    /// theme
    w_VAL_Theme_White = "スタンダード白";
    w_VAL_Theme_Blue = "スタンダード藍";

    /// quick
    w_QuickList_ListItem = "{0}リスト";
    w_QuickList_CreateItem = "{0}の作成";
    w_QuickList_EditItem = "{0}の編集";
    w_QuickList_DeleteItem = "{0}の削除";
    w_QuickList_TableEmpty = "{0}がいません";
    w_QuickList_Goto = "移動";
    w_QuickDetail_Title = "{0}詳細";
    w_QuickDetail_ShowSimple = "シンプル";
    w_QuickDetail_ShowDetail = "詳細";

    w_QuickCreate_BasicInformation = "基本情報";
    w_QuickCreate_UpdateInformation = "更新情報";
}
